export const ROOT_EMEMENT_ID = '#__next'
